import { ConsultantContractType } from "./enums";

export const BC_ContractsTypes = [
  ConsultantContractType.BC_Framework,
  ConsultantContractType.BC_Intermittent,
  ConsultantContractType.BC_Framework_Confirmation,
  ConsultantContractType.BC_Intermittent_Confirmation
];

export function isBonlivaCareContractType(contractType: ConsultantContractType): boolean {
  return BC_ContractsTypes.includes(contractType);
}
